"use client";

import { ChevronDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { RoadmapNavigationPath } from "./path-navigation/roadmap-navigation-path";

export const RoadmapNavigationMilestone = ({
  milestoneKey,
  milestonePaths,
  isExpanded,
  onToggle,
  paths,
  expandedPaths,
  onTogglePath,
  activePathId,
  activeStep,
  specialization,
  isFirst,
  tokenQuery,
  previewPathId,
}: {
  milestoneKey: number;
  milestonePaths: RoadmapPathVM[];
  isExpanded: boolean;
  onToggle: (key: number) => void;
  paths: RoadmapPathVM[];
  expandedPaths: Set<number>;
  onTogglePath: (index: number) => void;
  activePathId: number | null;
  activeStep?: RoadmapStepPreviewVM;
  specialization: RoadmapVM;
  isFirst: boolean;
  tokenQuery?: string;
  previewPathId?: number | null;
}) => {
  const milestone = milestonePaths[0]?.milestone;

  const milestoneCompletedSteps = milestonePaths.reduce(
    (acc, path) =>
      acc + path.steps.filter((s) => s.progress?.isCompleted).length,
    0,
  );
  const milestoneTotalSteps = milestonePaths.reduce(
    (acc, path) => acc + path.steps.length,
    0,
  );

  return (
    <div className="mb-6">
      {/* Milestone Header */}
      {milestone && (
        <button
          onClick={() => onToggle(milestoneKey)}
          className={cn(
            "group mb-1 flex w-full cursor-pointer items-center justify-between px-5 text-left",
            isExpanded ? "text-zinc-600" : "text-zinc-500",
          )}
        >
          <h3 className={cn("text-xs font-bold tracking-wide uppercase")}>
            {milestone.title}
          </h3>
          <div className={"flex items-center gap-2"}>
            <span className="text-xs font-medium tabular-nums">
              {milestoneCompletedSteps}/{milestoneTotalSteps}
            </span>
            <ChevronDownIcon
              size={16}
              className={cn("transition-all", isExpanded && "rotate-180")}
            />
          </div>
        </button>
      )}

      {/* Milestone Content (Paths + Steps) */}
      {isExpanded && (
        <div
          className={cn(
            "relative flex flex-col",
            isFirst ? "pt-0" : "pt-2",
            isExpanded && "pb-2",
          )}
        >
          {milestonePaths.map((path) => (
            <RoadmapNavigationPath
              key={path.id}
              path={path}
              paths={paths}
              expandedPaths={expandedPaths}
              onTogglePath={onTogglePath}
              activePathId={activePathId}
              activeStep={activeStep}
              specialization={specialization}
              isLastPath={
                milestonePaths[milestonePaths.length - 1].id === path.id
              }
              isFirstPath={milestonePaths[0].id === path.id}
              tokenQuery={tokenQuery}
              previewPathId={previewPathId}
            />
          ))}
        </div>
      )}
    </div>
  );
};
